module.exports = __webpack_public_path__ + "img/symbol_glaubeliebehoffnung.1680d47.jpg";